/* Feürzi — bouton d'achat façon Greenweez
   Le bouton « Ajouter au panier » se transforme en stepper − qty + synchronisé
   au panier (AJAX), sans ouvrir le tiroir. Stepper à 0 → retour au bouton.
   Feedback : bulle panier du header + toast. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-feurzi-atc]';

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function qtyInCart(cart, variantId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(variantId)) return items[i].quantity;
    }
    return 0;
  }

  /* Met à jour la pastille du header (à partir d'un objet cart) sans remplacer
     l'icône custom du thème. */
  function updateBubble(cart) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (cart.item_count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        link.appendChild(bubble);
      }
      var n = cart.item_count < 100 ? cart.item_count : '';
      bubble.innerHTML = '<span aria-hidden="true">' + n + '</span>';
      bubble.classList.remove('feurzi-bubble-pulse');
      void bubble.offsetWidth; /* reflow → relance l'animation */
      bubble.classList.add('feurzi-bubble-pulse');
    } else if (bubble) {
      bubble.parentNode.removeChild(bubble);
    }
  }

  /* Toast discret, auto-disparition. */
  var toastTimer = null;
  function toast(message) {
    var el = document.getElementById('feurzi-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'feurzi-toast';
      el.className = 'feurzi-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;

    /* Ancrage sous l'icône panier du header (haut droite) */
    var link = document.getElementById('cart-icon-bubble');
    if (link) {
      var r = link.getBoundingClientRect();
      el.style.top = (r.bottom + 10) + 'px';
      el.style.right = Math.max(8, window.innerWidth - r.right) + 'px';
      el.style.left = 'auto';
      el.style.bottom = 'auto';
    }

    el.classList.add('feurzi-toast--show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('feurzi-toast--show');
    }, 2500);
  }

  function initRoot(root) {
    if (root.dataset.feurziInit) return;
    root.dataset.feurziInit = '1';

    var variantId = root.getAttribute('data-variant-id');
    var form = root.querySelector('[data-feurzi-form]');
    var addBtn = root.querySelector('[data-feurzi-add]');
    var stepper = root.querySelector('[data-feurzi-stepper]');
    var qtyEl = root.querySelector('[data-feurzi-qty]');
    var minusBtn = root.querySelector('[data-feurzi-minus]');
    var plusBtn = root.querySelector('[data-feurzi-plus]');

    if (!form || !stepper || !qtyEl) return;

    function setState(qty) {
      qtyEl.textContent = qty > 0 ? qty : 1;
      if (qty > 0) root.classList.add('feurzi-atc--in-cart');
      else root.classList.remove('feurzi-atc--in-cart');
    }

    function lock(on) {
      if (on) root.setAttribute('data-loading', '1');
      else root.removeAttribute('data-loading');
    }
    function isLocked() {
      return root.hasAttribute('data-loading');
    }

    /* Ajout (interception du submit → AJAX, pas de rechargement / pas de tiroir) */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isLocked()) return;
      lock(true);
      root.classList.add('feurzi-atc--loading');
      postJSON('/cart/add.js', { id: variantId, quantity: 1 })
        .then(function () {
          return getCart();
        })
        .then(function (cart) {
          setState(qtyInCart(cart, variantId));
          updateBubble(cart);
          toast('Ajouté au panier ✓');
        })
        .catch(function (err) {
          console.error('[feurzi-atc] add', err);
        })
        .then(function () {
          lock(false);
          root.classList.remove('feurzi-atc--loading');
        });
    });

    /* +/- : met à jour la ligne panier ; 0 → retire → retour au bouton */
    function step(delta) {
      if (isLocked()) return;
      var current = parseInt(qtyEl.textContent, 10) || 0;
      var next = current + delta;
      if (next < 0) next = 0;
      lock(true);
      postJSON('/cart/change.js', { id: variantId, quantity: next })
        .then(function (cart) {
          setState(qtyInCart(cart, variantId));
          updateBubble(cart);
        })
        .catch(function (err) {
          console.error('[feurzi-atc] change', err);
        })
        .then(function () {
          lock(false);
        });
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { step(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { step(1); });

    /* --- Gestion des variantes (couleur, format…) --- */
    var variants = [];
    try {
      var vdata = root.querySelector('.feurzi-variants-data');
      if (vdata) variants = JSON.parse(vdata.textContent);
    } catch (e) { variants = []; }

    function money2(cents) {
      return (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    }

    /* Reconstruit le bloc prix pour la variante sélectionnée */
    function renderPriceDOM(v) {
      var el = document.querySelector('.feurzi-buybar__price .feurzi-price');
      if (!el) return;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var parts = money2(v.price).split(',');
      var html = '';
      if (onSale) {
        var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        html += '<div class="feurzi-price__public"><span class="feurzi-price__public-label">prix public</span>' +
          '<s class="feurzi-price__compare">' + money2(v.compare_at_price) + '€</s></div>';
      }
      html += '<div class="feurzi-price__row"><span class="feurzi-price__current">' +
        '<span class="feurzi-price__int">' + parts[0] + '</span>' +
        '<span class="feurzi-price__dec">,' + parts[1] + '€</span></span>';
      if (onSale) html += '<span class="feurzi-price__badge">-' + pct + '%</span>';
      html += '</div>';
      el.className = 'feurzi-price' + (onSale ? ' feurzi-price--on-sale' : '');
      el.innerHTML = html;
    }

    /* Lit les options cochées dans le sélecteur Dawn et trouve la variante */
    function currentSelectedVariant() {
      var vs = document.querySelector('variant-selects');
      if (!vs) return null;
      var opts = [];
      var fieldsets = vs.querySelectorAll('fieldset');
      if (fieldsets.length) {
        fieldsets.forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          if (checked) { opts.push(checked.value.trim()); return; }
          var sel = fs.querySelector('select');
          if (sel) opts.push(sel.value.trim());
        });
      } else {
        vs.querySelectorAll('select').forEach(function (sel) { opts.push(sel.value.trim()); });
      }
      if (!opts.length) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v['option' + (j + 1)] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function applyVariant(v) {
      if (!v) return;
      variantId = String(v.id);
      root.setAttribute('data-variant-id', variantId);
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;
      renderPriceDOM(v);
      var textEl = addBtn.querySelector('.feurzi-atc__add-text');
      if (v.available === false) {
        addBtn.setAttribute('disabled', 'disabled');
        if (textEl) textEl.textContent = 'Rupture de stock';
      } else {
        addBtn.removeAttribute('disabled');
        if (textEl) textEl.textContent = 'Ajouter au panier';
      }
      getCart().then(function (cart) { setState(qtyInCart(cart, v.id)); });
    }

    if (variants.length > 1 && document.querySelector('variant-selects')) {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('variant-selects')) {
          applyVariant(currentSelectedVariant());
        }
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
